import React, { FC } from 'react';
import { FormControlLabel, FormControlLabelProps, Switch, SwitchProps, styled } from '@mui/material';

import colors from 'src/utils/colors';

const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
  gap: 7,
  '.MuiTypography-root': {
    fontFamily: 'Roboto',
    fontSize: 14
  },
  '.MuiTypography-root.Mui-disabled': {
    color: colors.darkBlue
  }
});

export const StyledSwitch = styled(Switch)({
  width: 35,
  height: 19,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: colors.darkBlue,
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: 'red'
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 15,
    height: 15
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: colors.blueGrey,
    opacity: 1
  }
});

export type AppSwitchProps = {
  labelProps?: Omit<FormControlLabelProps, 'control'>;
  switchProps?: SwitchProps;
};

const AppSwitch: FC<AppSwitchProps> = ({ labelProps, switchProps }) => {
  const { label, ...restLabelProps } = labelProps || {};

  return (
    <StyledFormControlLabel
      label={label}
      control={<StyledSwitch {...switchProps} />}
      labelPlacement="top"
      {...restLabelProps}
    />
  );
};

export default AppSwitch;
